import { withProfiling } from '../self-measurements';
var getUFORouteName = withProfiling(function getUFORouteName(route) {
  if (route.ufoName != null) {
    return route.ufoName;
  }
  return route.name;
});
export default getUFORouteName;